module.exports = __webpack_public_path__ + "img/oie-logo-white-header.png";